import Flag from "@common/controls/Flag/component";
import Hint from "@common/controls/Hint/component";
import Select from "@common/controls/Inputs/Select/component";
import { type InputTypeProps, type OptionItem, type WithOptions } from "@common/declarations";
import withDynamicOptionsHOC from "@common/hocs/withDynamicOptions";
import React from "react";

const SUPPORTED_SYSTEM_LANGUAGES: string[] = [
  "de-DE",
  "en-US",
  "es-ES",
  "fr-FR",
  "hu-HU",
  "id-ID",
  "it-IT",
  "nl-NL",
  "pt-PT"
];

type Props = InputTypeProps<string | null> &
  WithOptions<OptionItem<string>> & {
    isLoading: boolean;
    excludeOptionValues?: string[];
  };
const SystemLanguageSelect = ({ options, ...props }: Props) => {
  const getLanguageCodeLabel = React.useCallback(
    (item: OptionItem<string>) => (
      <div className="fr fg sm">
        <Flag cultureCode={item.value} size={30} />
        <span>{item.label}</span>
        <Hint hint={item.value} />
      </div>
    ),
    []
  );
  return (
    <Select
      {...props}
      excludeOptionValues={props.excludeOptionValues}
      options={options}
      selectedLabel={getLanguageCodeLabel}
      renderItemLabel={getLanguageCodeLabel}
      value={props.value}
    />
  );
};
export default SystemLanguageSelect;

export const DynamicSystemLanguageSelect = withDynamicOptionsHOC<any, Props>(SystemLanguageSelect);
